const palette1 = ['#2d62ed', '#17AD37', '#FFAE03', '#FF3C38', '#A5978B']

export { palette1 }
